export const CONFIG = {
    default: { spacerHeight: 100, endSpace: 80 }
  }